if(!customElements.get('ani-embroidery-ui')){
customElements.define('ani-embroidery-ui',class extends HTMLElement{
connectedCallback(){
this.root=this.closest('.product-single');if(!this.root)return;
this.controller=new AbortController();
const update=()=>{
const fontLabel=this.root.querySelector('.pplr-tipo-de-letra > .pplrlabel');
if(fontLabel){for(const node of fontLabel.childNodes){if(node.nodeType===Node.TEXT_NODE && /tipo de letra/i.test(node.textContent))node.textContent=node.textContent.replace(/tipo de letra/ig,'TIPOGRAFÍA');}}

this.root.querySelectorAll('.pplr-texto textarea').forEach(el=>{
const text=this.dataset.placeholder;
if(el.placeholder!==text)el.placeholder=text;
if(el.getAttribute('d-placeholder')!==text)el.setAttribute('d-placeholder',text);
});
let variant;
try{variant=JSON.parse(this.root.querySelector('[data-selected-variant]')?.textContent||'null');}catch{return;}
const button=this.root.querySelector('[data-add-to-cart]:not([data-upsell-btn])');
const label=button?.querySelector('[data-add-to-cart-text]');
if(!label||!variant)return;
const available=Boolean(variant.available);
button.classList.toggle('ani-embroidery-total-button',available);
if(!available){label.querySelector('[data-ani-embroidery-total]')?.remove();return;}
const lang=(document.documentElement.lang||'es').split('-')[0];
const copy={es:'PERSONALIZAR Y AÑADIR',en:'PERSONALIZE AND ADD',de:'PERSONALISIEREN UND HINZUFÜGEN'}[lang]||'PERSONALIZAR Y AÑADIR';
const textNode=Array.from(label.childNodes).find(node=>node.nodeType===Node.TEXT_NODE&&node.textContent.trim());
if(textNode&&textNode.textContent!==copy)textNode.textContent=copy;
const cuff=this.root.querySelector('[data-ani-cuff]');
const extra=cuff?.querySelector('[data-cuff-enabled]')?.checked?(cuff.querySelector('[data-cuff-heart]')?.value==='Con'?1500:1100):0;
const form=button.form||button.closest('form');
const quantity=Math.max(1,Number(form?.querySelector('[name="quantity"]')?.value)||1);
const total=(Number(variant.price)+extra)*quantity;
if(!Number.isFinite(total))return;
let price=label.querySelector('[data-ani-embroidery-total]');
if(!price){price=document.createElement('span');price.dataset.aniEmbroideryTotal='';label.append(price);}
const formatted=' · '+new Intl.NumberFormat(document.documentElement.lang||'es',{style:'currency',currency:window.Shopify?.currency?.active||'EUR'}).format(total/100);
if(price.textContent!==formatted)price.textContent=formatted;
};
this.update=update;
this.root.addEventListener('change',update,{signal:this.controller.signal});
this.root.addEventListener('input',update,{signal:this.controller.signal});
this.root.addEventListener('theme:variant:prices-updated',update,{signal:this.controller.signal});
this.observer=new MutationObserver(update);
this.observer.observe(this.root,{childList:true,subtree:true,characterData:true});
this.styleNode=document.createElement('style');
this.styleNode.textContent='.ani-embroidery-total-button [data-product-price],.ani-embroidery-total-button [data-compare-price]{display:none!important}.ani-embroidery-total-button [data-add-to-cart-text]::after{display:none!important}';
this.append(this.styleNode);
update();
}
disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();this.styleNode?.remove();}
});
}